import { useCallback } from 'react';

import FormWrapper from '@/components/form/Wrapper';
import { useAppAlert } from '@Components/AppAlert';

import Form from '../components/Form';
import { SettingProvider, useSettingStore } from '../store';

const SettingForm = () => {
  const { siteSelected: { id: siteId }, collection: { item, useLoad, useSubmit, reset } } = useSettingStore()
  const { handleSuccess, handleError } = useAppAlert()

  const loadData = useLoad(siteId)
  const handleSubmit = useSubmit()

  const handleSubmitSetting = useCallback(async payload => {
    try {
      await handleSubmit(payload)
      reset()
      await loadData()
      handleSuccess('Success', 'Settings saved.');
    } catch (err) {
      handleError('Error', 'Settings was not saved.');
    }
  }, [handleSubmit, reset, loadData, handleSuccess, handleError]);

  if (!item) {
    return null
  }

  return <>
    <FormWrapper title="Revenue Scrub">
      <Form data={item} handleSubmit={handleSubmitSetting} />
    </FormWrapper>
  </>
};

export default function SettingFormLayout() {
  return <SettingProvider>
    <SettingForm />
  </SettingProvider>
}
